export default "__VITE_ASSET__DJsRq3Kk__"